import React from "react";

export default function GarageIcon(props: any) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30 23.9996H29V12.3334C29 12.0042 28.9188 11.6802 28.7635 11.39C28.6083 11.0997 28.3838 10.8523 28.11 10.6696L17.11 3.33588C16.7815 3.11687 16.3955 3 16.0006 3C15.6058 3 15.2198 3.11687 14.8912 3.33588L3.89125 10.6696C3.61722 10.8522 3.3925 11.0995 3.23702 11.3898C3.08154 11.68 3.00013 12.0041 3 12.3334V23.9996H2C1.73478 23.9996 1.48043 24.105 1.29289 24.2925C1.10536 24.4801 1 24.7344 1 24.9996C1 25.2648 1.10536 25.5192 1.29289 25.7067C1.48043 25.8943 1.73478 25.9996 2 25.9996H30C30.2652 25.9996 30.5196 25.8943 30.7071 25.7067C30.8946 25.5192 31 25.2648 31 24.9996C31 24.7344 30.8946 24.4801 30.7071 24.2925C30.5196 24.105 30.2652 23.9996 30 23.9996ZM17 15.9996H24V18.9996H17V15.9996ZM15 18.9996H8V15.9996H15V18.9996ZM8 20.9996H15V23.9996H8V20.9996ZM17 20.9996H24V23.9996H17V20.9996Z"
        fill="black"
      />
    </svg>
  );
}
